// extracted by mini-css-extract-plugin
export default {"mapContainer":"BrowsePage_mapContainer__+GIej"};